import { FormattedMessage, useIntl } from 'react-intl';
import connectGarminCoros from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/connectGarminCoros';
import liveShare from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/liveShare';
import memberDeals from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/memberDeals';
import offlineMaps from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/offlineMaps';
import realTimeTrailConditions from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/realTimeTrailConditions';
import trailConditions from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/trailConditions';
import unlimitedMapDownloads from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/unlimitedMapDownloads';
import UpsellFeatureList from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/UpsellFeatureList';
import wrongTurnAlerts from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/wrongTurnAlerts';

type Props = {
  isInUs: boolean;
  isRei?: boolean;
  memberDealsFirst?: boolean;
};

export default function PlusMembershipIncludes({ isInUs, isRei, memberDealsFirst }: Props) {
  const intl = useIntl();

  if (isRei) {
    return (
      <UpsellFeatureList
        features={[
          unlimitedMapDownloads(intl),
          {
            ...realTimeTrailConditions(intl),
            headline: intl.formatMessage({ defaultMessage: 'Real-time Trail Conditions' })
          },
          wrongTurnAlerts(intl),
          connectGarminCoros(intl)
        ]}
        label={<FormattedMessage defaultMessage="Everything you need to discover, plan, and navigate" />}
      />
    );
  }

  const connectGarminCorosFeature = connectGarminCoros(intl);
  const liveShareFeature = liveShare(intl);
  const memberDealsFeature = memberDeals(intl);
  const offlineMapsFeature = offlineMaps(intl);
  const trailConditionsFeature = trailConditions(intl);
  const wrongTurnAlertsFeature = wrongTurnAlerts(intl);

  const usDefaultFeatures = [offlineMapsFeature, trailConditionsFeature, memberDealsFeature, wrongTurnAlertsFeature, connectGarminCorosFeature];
  const usMemberDealsFirstFeatures = [
    memberDealsFeature,
    offlineMapsFeature,
    trailConditionsFeature,
    wrongTurnAlertsFeature,
    connectGarminCorosFeature
  ];
  const nonUsFeatures = [offlineMapsFeature, trailConditionsFeature, wrongTurnAlertsFeature, connectGarminCorosFeature, liveShareFeature];
  const features = isInUs ? (memberDealsFirst ? usMemberDealsFirstFeatures : usDefaultFeatures) : nonUsFeatures;

  return <UpsellFeatureList features={features} label={<FormattedMessage defaultMessage="Plus membership includes" />} variant="compact" />;
}
